import React, { useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import VideoPlayer from './components/VideoPlayer';
import Notes from './components/Notes';
import Spin from 'components/common/Spin';
import apiClient from "utils/api-client";
import useSnack from "hooks/useSnack";

const useStyles = makeStyles((theme) => ({
  control: {
    padding: theme.spacing(1),
  },
}));

const MeetingView = ({ location, match }) => {
  const classes = useStyles();
  const [url, setUrl] = useState();
  const snack = useSnack();
  const confId = match?.params?.conferenceId;

  useEffect(() => {
    apiClient.get(`/twilio/video/${confId}/download`).then(
      (resp) => {
        setUrl(resp.url);
      },
      (e) => {
        snack.error(e.message);
      },
    );
  }, [confId]);

  if (!url) return <Spin spinning linear />;

  const videoJsOptions = {
    controls: true,
    preload: true,
    userActions: { hotkeys: true },
    playbackRates: [0.5, 1, 1.5, 2],
    sources: [
      {
        src: url,
        type: 'video/mp4',
      },
    ],
  };


  return (
    <div>
      <Grid container>
        <Grid item xs={12} lg={7} className={classes.control}>
          <VideoPlayer
            confId={confId}
            videoJsOptions={videoJsOptions}
          />
        </Grid>
        <Grid item xs={12} lg={5} className={classes.control}>
          <Notes confId={confId} />
        </Grid>
      </Grid>
    </div>
  );
};

export default MeetingView;
